import { Component, Input, DoCheck } from '@angular/core';
import { IEvent } from 'src/app/models/event.model';
import { ITicketType } from 'src/app/models/ticket.model';
import { FilesHandler } from 'src/app/services/file-handler.service';

@Component({
  selector: 'app-ticket-preview',
  templateUrl: './ticket-preview.component.html',
  styleUrls: ['./ticket-preview.component.scss']
})
export class TicketPreviewComponent implements DoCheck {
  @Input() public event: IEvent;
  @Input() public ticketType: ITicketType;
  public base64Image: string;
  public base64SecondaryImage: string;
  public blobImage: Blob;
  public blobSecondaryImage: Blob;
  public isVideo = false;
  public isVideoSecondary = false;
  public videoLocalUrl: any;

  constructor(private filesHandler: FilesHandler) {

  }

  private async setBase64Image(): Promise<void> {
    this.blobImage = this.ticketType ? this.ticketType.ticketVisual.image: this.event?.ticketing?.ticketVisual?.image
    this.base64Image = await this.filesHandler.getBase64(this.blobImage);
  }

  private async setBase64SecondaryImage(): Promise<void> {
    this.blobSecondaryImage = this.ticketType ? this.ticketType.ticketVisual.secondaryImage: this.event?.ticketing?.ticketVisual?.secondaryImage
    this.base64SecondaryImage = await this.filesHandler.getBase64(this.blobSecondaryImage);
  }

  ngDoCheck() {
    if (this.ticketType && this.blobImage !== this.ticketType.ticketVisual.image) {
      this.checkFormat(this.ticketType.ticketVisual.image);
    } else if (!this.ticketType && this.blobImage !== this.event?.ticketing?.ticketVisual?.image) {
      this.checkFormat(this.event.ticketing.ticketVisual.image);
    }

    if (this.ticketType && this.blobSecondaryImage !== this.ticketType.ticketVisual.secondaryImage) {
      this.checkFormat(this.ticketType.ticketVisual.secondaryImage, 'secondary');
    } else if (!this.ticketType && this.blobSecondaryImage !== this.event?.ticketing?.ticketVisual?.secondaryImage) {
      this.checkFormat(this.event.ticketing.ticketVisual.secondaryImage, 'secondary');
    }
  }

  getTicketCustomText() {
    const text = this.event.ticketing.ticketVisual?.text || ""
    const strippedText = text.replace(/(<([^>]+)>)/gi, "");
    if (strippedText === '') {
      return ''
    }
    return text
  }

  checkFormat(_visual, type: 'first' | 'secondary' = 'first') {
    if (_visual) {
      if (_visual.type === 'video/mp4') {
        this.isVideo = true;
        let file = new File([_visual], 'file', { type: _visual.type });
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (event) => {
          this.videoLocalUrl = (<FileReader>event.target).result;
        }
      } else {
        if (type === 'first') {
          this.isVideo = false;
          this.setBase64Image();
        } else {
          this.isVideoSecondary = false;
          this.setBase64SecondaryImage();
        }
      }
    } else {
      if (type === 'first') {
        this.isVideo = false;
        this.base64Image = null;
      } else {
        this.isVideoSecondary = false;
        this.base64SecondaryImage = null;
      }
    }
  }
}
